<template>
	<div v-if="accountPriceApply.platformType == 'weibo'" style="margin-top: 10px;">
		<h4 style="text-align: center;">合集价格矩阵表({{accountPriceApply.accountPriceMonth}})</h4>
		<a-table :columns="columnsPrice" :dataSource="data" bordered size="middle" :pagination="false" >
			<template v-for="item2 in columnsPrice[1].children" :slot="item2.dataIndex" slot-scope="text, record">
				<!-- <div style="background-color: beige">
					{{formatOriginal(record,item2.dataIndex)}}
				</div>
				<div  :class="['editableFrame',formatStyle(record,item2.dataIndex)]">
					<div v-if="!canEdit">{{text}}</div>
					<div v-else>
						<editable-cell :text="text" @change="onCellChange(record, item2.dataIndex, $event, 'cost')" />
					</div>
				</div> -->
				{{text}}
			</template>
			<template v-for="item1 in columnsPrice[2].children" :slot="item1.dataIndex" slot-scope="text, record">
				<div style="background-color: beige">
					{{formatOriginal(record,item1.dataIndex)}}
				</div>
				<div :class="['editableFrame',formatStyle(record,item1.dataIndex)]">
					<div v-if="!canEdit">{{text}}</div>
					<div v-else>
						<editable-cell :text="text" @change="onCellChange(record, item1.dataIndex, $event)" />
					</div>
				</div>
			</template>
		</a-table>

		<a-form-item labelAlign="left" label="图文备注" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }" style="margin-top: 20px;">
			<a-input :disabled="!canEdit" type="textarea" v-model="accountPriceApply.graphicRemark"  placeholder="请输入图文备注"  @blur="saveAccountPriceApplyField({graphicRemark: accountPriceApply.graphicRemark})"/>
		</a-form-item>

		<a-form-item labelAlign="left" label="视频备注" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
			<a-input :disabled="!canEdit" type="textarea" v-model="accountPriceApply.videoRemark"  placeholder="请输入视频备注"  @blur="saveAccountPriceApplyField({videoRemark: accountPriceApply.videoRemark})"/>
		</a-form-item>

		<a-form-item labelAlign="left" label="备注" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
			<a-input :disabled="!canEdit" type="textarea" v-model="accountPriceApply.remark"  placeholder="请输入备注" @blur="saveAccountPriceApplyField({remark: accountPriceApply.remark})"/>
		</a-form-item>
	</div>
</template>

<script>
import moment from 'moment';
import EditableCell from '@/components/editableCell/editableCell';

export default {
	components: { EditableCell },
	props: {
		accountPriceApply: {
			type: Object,
			default: null
		},
		canEdit: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		accountPriceApply: {
			immediate: true,
			handler(newVal, oldVal) {
				let accountId = newVal.accountId;
				let platformType = newVal.platformType;
				let accountPriceMonth = newVal.accountPriceMonth;
				if(platformType == 'weibo' && accountId && accountPriceMonth){
					this.getPriceDataList();
				}
			},
			// deep: true
		},
	},
	data() {
		return {
			columnsPrice: [
				{
					title: '发布类型',
					dataIndex: 'releaseType',
					align:'center',
					width:'10%',
				},
				{
					title: '微任务',
					width: '10%',
					children: [],
					align:'center',
				},
				{
					title: '位置',
					width: '40%',
					children: [],
					align:'center',
				},
			],
			data: [],
		};
	},
	mounted() {
		var that = this;
		//微任务成本
		that.$get('/weiboElement/list',{type:'collection_microtask'}).then(res => {
			that.columnsPrice[1].children=[];
			for(var i of res.data.data){
				that.columnsPrice[1].children.push(
					{
						title: i.name,
						dataIndex: i.id,
						align:'center',
						scopedSlots: { customRender: i.id },
					}
				);
			}
		});
		//发布类型
		that.$get('/weiboElement/list',{type:'collection_content_type'}).then(res => {
			that.columnsPrice[2].children=[];
			for(var i of res.data.data){
				that.columnsPrice[2].children.push(
					{
						title: i.name,
						dataIndex: i.id,
						align:'center',
						scopedSlots: { customRender: i.id }
					}
				);
			}
		});
	},
	methods: {
		formatStyle(record, index) {
			let status = record['status_' + index];
			if(status == 1){
				return 'add'
			}else if (status == 2){
				return 'delete';
			}else if (status == 3){
				return 'modify'
			}
			return '';
		},
		formatOriginal(record, index) {
			let status = record['status_' + index];
			if(status == 3){
				return record['originalPrice_' + index];
			}
			return '';
		},
		onCellChange(record, dataIndex, value, type) {
			var data = {
				accountPriceApplyId: this.accountPriceApply.id,
				releaseType: record.releaseKey,
				whetherMicrotask: record.whetherMicrotask=='1'?'1':'0',
				elementId: dataIndex,
			};
			if (value && parseFloat(value) >= 0) {
				data.price = parseFloat(value).toFixed(2);
				this.$post('/weiboPriceApply/save', data).then(res => {
					this.getPriceDataList();
				});
			} else {
				this.$delete('/weiboPriceApply/delete', data).then(res => {
					this.getPriceDataList();
				});
			}
		},
		getPriceDataList() {
			this.data = [];
			this.$get('/weiboPriceApply/listPrice/weibo_collection_release_type', { accountPriceApplyId: this.accountPriceApply.id}).then(res => {
				this.data = res.data;
			});
		},
		saveAccountPriceApplyField(data){
			var param = {
				...data,
				id: this.accountPriceApply.id
			};
			this.$post('/accountPriceApply/saveAccountPriceApplyField', param);
		}
	},
};
</script>

<style lang="less" scoped>
	.add{
		background-color: palegreen;
	}
	.delete{
		background-color: orangered;
	}
	.modify{
		background-color: yellow;
	}
/deep/.editableFrame {
	.editable-cell {
		position: relative;
	}

	.editable-cell-input-wrapper,
	.editable-cell-text-wrapper {
		padding-right: 24px;
	}

	.editable-cell-text-wrapper {
		padding: 5px 24px 5px 5px;
	}

	.editable-cell-icon,
	.editable-cell-icon-check {
		position: absolute;
		right: 0;
		width: 20px;
		cursor: pointer;
	}

	.editable-cell-icon {
		line-height: 18px;
		display: none;
	}

	.editable-cell-icon-check {
		line-height: 28px;
	}

	.editable-cell:hover .editable-cell-icon {
		display: inline-block;
	}

	.editable-cell-icon:hover,
	.editable-cell-icon-check:hover {
		color: #108ee9;
	}

	.editable-add-btn {
		margin-bottom: 8px;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/account/accountChange/accountPrice/weiboCollectionPrice.vue